<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="700"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          v-on="on"
          title='Agregar contacto'
          ref='activatorButton'
        >
          Agregar Contacto<v-icon>mdi-account-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Agregar Contacto</v-card-title>
        <v-card-text>
          <v-row><v-col></v-col></v-row>
          <v-row>
            <v-col cols="12" sm="8" md="6">
              <v-text-field
                v-model="contacto.nombre"
                requied
                placeholder="Nombre"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="8" md="6">
              <v-text-field placeholder='Correo Electronico' v-model="contacto.correo" @keypress='restrictCharsEmail($event)' :rules='email' solo>
              </v-text-field>
            </v-col>
             <v-col cols="12" sm="8" md="6">
              <v-text-field
                v-model="contacto.razonSocial"
                placeholder="Razon Social"
                solo
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="6" md="4">
              <v-text-field
                v-model="contacto.rfc"
                placeholder="RFC"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="10" sm="6" md="4">
              <v-text-field
                v-model="contacto.sms"
                placeholder="SMS"
                solo
                @keypress='restrictCharsSms($event)'
                id="smsField"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="addContacto()"
            :disabled="awaitingResponse || !dialog"
          >
            Agregar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  import { removeWhitespace } from '@/utils/checkQuery.js';
  export default {
    data () {
      return {
        dialog: false,
        email: [
          (value) => (value === '' || /^[\w-]+(\.[\w-]+)*@(\w([\w-]+\w)*)+(\.(\w([\w-]+\w)*)+)*(\.\w{2,3})+$/.test(value)) || 'Email inválido',
        ],
        rfcValid: false,
        contacto: {
          correo: '',
          nombre: '',
          razonSocial: '',
          rfc: '',
          sms: ''
        },
        awaitingResponse: false,
      }
    },
    mounted(){
    },
    methods:{
      restrictCharsEmail($event) {
        if ((this.contacto.correo.indexOf('@') === -1) && ($event.charCode === 64)) {
          return true;
        } else if ($event.charCode !== 64) {
            return true;
        }
        $event.preventDefault();
      },
      restrictCharsSms($event) {
        if ($event.charCode > 47 && $event.charCode < 58) return;
        let cursorPosition = document.getElementById('smsField').selectionEnd;
        if ($event.charCode === 43 && cursorPosition === 0 && this.contacto.sms.indexOf('+') === -1) return;
        $event.preventDefault();
      },
      async addContacto(){
        if(!(await this.isValidContacto())) return;
        const defaultToastMessage = 'Error al agregar el contacto.';
        const defaultConsoleMessage = 'addContacto error';
        try {
          this.awaitingResponse = true;
          const clienteId = this.$store.getters.getClient;
          const contacto = JSON.parse(JSON.stringify(this.contacto));
          const result = await this.$store.dispatch('addContacto',{clienteId, contacto});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          this.$emit('reload');
          this.dialog = false;
          for (const key in this.contacto) this.contacto[key] = '';
          this.$toast.success("Contacto Nuevo: " + contacto.nombre);
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.stopWait();
      },
      validarNombre() {
        if (removeWhitespace(this.contacto.nombre).length === 0) {
          this.$toast.error('Falta el nombre del contacto');
          return false;
        }
        return true;
      },
      validarCorreo() {
        if (/^[\w-]+(\.[\w-]+)*@(\w([\w-]+\w)*)+(\.(\w([\w-]+\w)*)+)*(\.\w{2,3})+$/.test(this.contacto.correo)) return true;
        this.$toast.error('Correo inválido');
        return false;
      },
      async validarRFC(){
        if (removeWhitespace(this.contacto.rfc).length === 0) return true;
        const defaultToastMessage = 'Error al validar el RFC.';
        const defaultConsoleMessage = 'checkRFC error';
        try {
          const rfc = this.contacto.rfc.toUpperCase();
          this.contacto.rfc = rfc;
          const result = await this.$store.dispatch('RFCValid', {rfc});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return false;
          }
          return result;
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
          return false;
        }
      },
      async isValidContacto() {
        if (!this.validarNombre()) return false;
        if (!this.validarCorreo()) return false;
        if (!(await this.validarRFC())) return false;
        return true;
      },
      stopWait() {
        var self = this;
        window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
      },
    },
  }
</script>